
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-amber-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/decae7cc1212f168c5dab152d5c92441/815f68b8f034d8bf8d9f20bbe7b78c92.png" 
                alt="Holman Brown Design" 
                className="h-10 w-auto"
              />
              <span className="ml-3 text-xl font-semibold">Holman Brown Design</span>
            </div>
            <p className="text-amber-100 mb-6 max-w-md">
              Handcrafted bespoke wooden bowls made from locally sourced northeast Ohio wood. Each piece is a unique work of art celebrating natural beauty and fine craftsmanship.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-pinterest-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Products
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-amber-100">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-lg mr-2 mt-1"></i>
                <span className="text-sm">18175 Shaw Rd, Hiram Ohio 44234</span>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-lg mr-2 mt-1"></i>
                <span className="text-sm">Holmanbrownfurniture@gmail.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line text-lg mr-2 mt-1"></i>
                <span className="text-sm">330-977-1170</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-amber-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-amber-100 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Holman Brown Design. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
